import { render, staticRenderFns } from "./groupOrderDetails.vue?vue&type=template&id=4c9658c0&"
import script from "./groupOrderDetails.vue?vue&type=script&lang=js&"
export * from "./groupOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./groupOrderDetails.vue?vue&type=style&index=0&id=4c9658c0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports